/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportBusinessResponseItem
 */
export interface ImportBusinessResponseItem {
    /**
     * 
     * @type {boolean}
     * @memberof ImportBusinessResponseItem
     */
    isSuccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportBusinessResponseItem
     */
    isNew?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessResponseItem
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessResponseItem
     */
    businessId?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBusinessResponseItem
     */
    chowlyApi?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportBusinessResponseItem
     */
    oloVendorId?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportBusinessResponseItem
     */
    createdAt?: number;
}

/**
 * Check if a given object implements the ImportBusinessResponseItem interface.
 */
export function instanceOfImportBusinessResponseItem(value: object): value is ImportBusinessResponseItem {
    return true;
}

export function ImportBusinessResponseItemFromJSON(json: any): ImportBusinessResponseItem {
    return ImportBusinessResponseItemFromJSONTyped(json, false);
}

export function ImportBusinessResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportBusinessResponseItem {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'isNew': json['isNew'] == null ? undefined : json['isNew'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'businessId': json['businessId'] == null ? undefined : json['businessId'],
        'chowlyApi': json['chowlyApi'] == null ? undefined : json['chowlyApi'],
        'oloVendorId': json['oloVendorId'] == null ? undefined : json['oloVendorId'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function ImportBusinessResponseItemToJSON(json: any): ImportBusinessResponseItem {
    return ImportBusinessResponseItemToJSONTyped(json, false);
}

export function ImportBusinessResponseItemToJSONTyped(value?: ImportBusinessResponseItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'isNew': value['isNew'],
        'errorMessage': value['errorMessage'],
        'businessId': value['businessId'],
        'chowlyApi': value['chowlyApi'],
        'oloVendorId': value['oloVendorId'],
        'createdAt': value['createdAt'],
    };
}

